import { FC } from "react";
import { PatrolConfiguration } from "../../../http/patrol/types/configurations";
import { PatrolComponentsFormBody } from "../patrol/PatrolComponents";
import { PatrolDefaultSupportSelectionFormBody } from "../patrol/PatrolDefaultSupportSelection";
import { PatrolGeneralDataFormBody } from "../patrol/PatrolGeneralData";
import { PatrolRoofInfoFormBody } from "../patrol/PatrolRoofInfo";
import { PatrolShuttleFormBody } from "../patrol/PatrolShuttles";
import KonvaCanvas from "./KonvaCanvas";

export interface UpdatePatrolConfigurationFormBody {
  generalData: PatrolGeneralDataFormBody;
  roofInfo: PatrolRoofInfoFormBody;
  supportSelection: PatrolDefaultSupportSelectionFormBody;
  components: PatrolComponentsFormBody;
  shuttle: PatrolShuttleFormBody;
}

export interface PatrolProps {
  configuration: PatrolConfiguration;
  isAdmin?: boolean;
}

const Patrol: FC<PatrolProps> = ({ configuration, isAdmin }) => {
  return <KonvaCanvas configuration={configuration} isAdmin={isAdmin} />;
};

export default Patrol;
